import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading, menuMaster } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  // set drawer state: prefer persisted choice, else responsive default
  useEffect(() => {
    try {
      const saved = localStorage.getItem('drawer_open');
      if (saved === 'open') {
        handlerDrawerOpen(true);
        return;
      }
      if (saved === 'closed') {
        handlerDrawerOpen(false);
        return;
      }
    } catch {}
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={(theme) => ({
          width: {
            xs: '100%',
            lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)`
          },
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.easeInOut,
            duration: 280
          })
        })}
      >
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {window?.location?.pathname?.startsWith('/areas/informes') ? null : <Breadcrumbs />}
         <Outlet />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
